/**
 * Retourne document.referrer uniquement s'il provient d'un hostname externe.
 * Fallback sur les params URL `referer` ou `ref` si pas de referrer natif.
 * Retourne '' si le referrer est interne ou absent.
 */
export function getExternalReferrer(): string {
  let referrer = document.referrer;

  // Fallback sur les URL params si pas de referrer natif
  if (!referrer) {
    const params = new URLSearchParams(window.location.search);
    referrer = params.get('referer') ?? params.get('ref') ?? '';
  }

  if (!referrer) return '';

  // Ne retourner que si c'est un referrer externe (hostname différent)
  try {
    const referrerHost = new URL(referrer).hostname;
    return referrerHost !== window.location.hostname ? referrer : '';
  } catch {
    // URL malformée → ignorer
    return '';
  }
}

/**
 * Détermine la source logique du visiteur.
 * Priorité : utm_source > hostname du referrer > ''.
 */
export function getWebsiteSource(utmSource: string, referrer: string): string {
  if (utmSource) return utmSource;
  if (referrer) {
    try {
      return new URL(referrer).hostname;
    } catch {
      return '';
    }
  }
  return '';
}
